module.exports = __webpack_public_path__ + "media/images/monthly5-98ca7bfdfb8e4178879194769fd99577.jpg";